import React, { Fragment, useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { GET_ARTICULOS, ADD_ARTICULO } from '../../graphql/actions/articulo';
// nodejs library that concatenates classes
import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import CustomInput from '../UI/CustomInput/CustomInput.js';
import Button from '../UI/CustomButtons/Button.js';
import Spinner from '../UI/Spinner/Spinner';
import Notification from '../Notification/Notification';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';
// Validations
import { isEmpty, countWords } from '../../util/validators';

import sectionAddStyle from '../../assets/jss/coscef/views/articuloSections/sectionAddStyle';

const useStyles = makeStyles(sectionAddStyle);
const editorConfiguration = {
  language: 'es',
};

const ArticuloAdd = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);
  const classes = useStyles();
  const [formTitulo, setFormTitulo] = useState('');
  const [formAutor, setFormAutor] = useState('');
  const [formDescripcionAutor, setFormDescripcionAutor] = useState('');
  const [formResumen, setFormResumen] = useState('');
  const [formEtiquetas, setFormEtiquetas] = useState('');
  const [addForm, setAddForm] = useState({
    titulo: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    autor: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    descripcionAutor: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    resumen: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty, countWords({ min: 30, max: 38 })],
    },
    contenido: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    etiquetas: {
      value: '',
      valid: true,
      touched: false,
      validators: [isEmpty, countWords({ min: 2, max: 3 })],
    },
  });
  const [formIsValid, setFormIsValid] = useState(false);

  const inputChangedHandler = (value, input) => {
    let isValid = true;

    for (let validator of addForm[input].validators) {
      isValid = isValid && validator(value);

      if (input === 'titulo') {
        if (isValid) setFormTitulo('success');
        else setFormTitulo('error');
      }
      if (input === 'autor') {
        if (isValid) setFormAutor('success');
        else setFormAutor('error');
      }
      if (input === 'descripcionAutor') {
        if (isValid) setFormDescripcionAutor('success');
        else setFormDescripcionAutor('error');
      }
      if (input === 'resumen') {
        if (isValid) setFormResumen('success');
        else setFormResumen('error');
      }
      if (input === 'etiquetas') {
        if (isValid) setFormEtiquetas('success');
        else setFormEtiquetas('error');
      }
    }

    const updatedForm = {
      ...addForm,
      [input]: {
        ...addForm[input],
        valid: isValid,
        value: value,
      },
    };

    let formIsValid = true;
    for (const inputName in updatedForm) {
      formIsValid = formIsValid && updatedForm[inputName].valid;
    }

    setAddForm(updatedForm);
    setFormIsValid(formIsValid);
  };

  const redirectToArticulos = (data) => {
    //console.log(data);
    if (data.createArticulo) props.history.push('/articulos');
    else console.log('Error adicionando articulo.');
  };

  const updateCacheAdd = (cache, { data }) => {
    const { getArticulos } = cache.readQuery({
      query: GET_ARTICULOS,
      variables: {
        paginate: {
          numArticulos: 9,
          cursor: '',
          sortBy: { field: 'createdAt', order: 'ASC' },
        },
      },
    });

    const nuevoArticulo = data?.createArticulo;

    if (getArticulos && nuevoArticulo) {
      cache.writeQuery({
        query: GET_ARTICULOS,
        variables: {
          paginate: {
            numArticulos: 9,
            cursor: '',
            sortBy: { field: 'createdAt', order: 'ASC' },
          },
        },
        data: {
          getArticulos: {
            articulos: [nuevoArticulo, ...getArticulos?.articulos],
          },
        },
      });
    }
  };

  const [
    createArticulo,
    {
      loading: loadingAddArticulo,
      error: errorAddArticulo,
      data: dataAddArticulo,
    },
  ] = useMutation(ADD_ARTICULO, {
    errorPolicy: 'all',
    update: updateCacheAdd,
    onCompleted: (data) => redirectToArticulos(data),
  });

  const adicionarHandler = (event) => {
    event.preventDefault();

    const articuloData = {};
    for (let i in addForm) {
      articuloData[i] = addForm[i].value;
    }

    createArticulo({
      variables: {
        input: {
          titulo: articuloData.titulo,
          autor: articuloData.autor,
          descripcionAutor: articuloData.descripcionAutor,
          resumen: articuloData.resumen,
          contenido: articuloData.contenido,
          etiquetas: articuloData.etiquetas,
        },
      },
    });

    //console.log(articuloData);
  };

  let seccionTitulo = (
    <div className={classes.section}>
      <GridContainer justify='center'>
        <GridItem xs={12} sm={8} md={8}>
          <h2 className={classes.title}>Crear Articulo</h2>
        </GridItem>
      </GridContainer>
    </div>
  );

  let seccionButton = (
    <GridContainer>
      <GridItem
        md={4}
        sm={4}
        className={classNames(
          classes.mrAuto,
          classes.mlAuto,
          classes.textCenter
        )}
      >
        <Button type='submit' color='dark' round disabled={!formIsValid}>
          Crear Articulo
        </Button>
      </GridItem>
    </GridContainer>
  );

  let seccionFormulario = (
    <div id='formularioAdd'>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <form onSubmit={adicionarHandler}>
            <GridContainer>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText='Título (*)'
                  success={formTitulo === 'success'}
                  error={formTitulo === 'error'}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => {
                      inputChangedHandler(event.target.value, 'titulo');
                    },
                  }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText='Autor (*)'
                  success={formAutor === 'success'}
                  error={formAutor === 'error'}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => {
                      inputChangedHandler(event.target.value, 'autor');
                    },
                  }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText='Descripción del autor (*)'
                  success={formDescripcionAutor === 'success'}
                  error={formDescripcionAutor === 'error'}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => {
                      inputChangedHandler(
                        event.target.value,
                        'descripcionAutor'
                      );
                    },
                    multiline: true,
                    rows: 2,
                  }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText='Resumen (De 30 a 38 palabras)'
                  success={formResumen === 'success'}
                  error={formResumen === 'error'}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => {
                      inputChangedHandler(event.target.value, 'resumen');
                    },
                    multiline: true,
                    rows: 6,
                  }}
                />
              </GridItem>
              <GridItem md={12} sm={12}>
                <div className={classes.control}>
                  <p className={classes.label}>Contenido</p>
                  <CKEditor
                    //disabled={true}
                    editor={ClassicEditor}
                    data='<br /><br /><br /><br /><br /><br />'
                    config={editorConfiguration}
                    onReady={(editor) => {
                      // You can store the "editor" and use when it is needed.
                      //console.log('Editor is ready to use!', editor);
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      inputChangedHandler(data, 'contenido');
                      //console.log({ event, editor, data });
                    }}
                  />
                </div>
              </GridItem>
              <GridItem md={12} sm={12}>
                <CustomInput
                  labelText='Etiquetas (De 2 a 3 palabras)'
                  success={formEtiquetas === 'success'}
                  error={formEtiquetas === 'error'}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => {
                      inputChangedHandler(event.target.value, 'etiquetas');
                    },
                  }}
                />
              </GridItem>
            </GridContainer>
            {seccionButton}
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
  let showNotification = null;

  if (loadingAddArticulo) seccionButton = <Spinner color='gray' />;

  if (errorAddArticulo) {
    showNotification = errorAddArticulo.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorAddArticulo ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataAddArticulo && dataAddArticulo.createArticulo) {
    const { createArticulo } = dataAddArticulo;
    if (createArticulo.success && createArticulo.code === '201') {
      showNotification = (
        <Notification
          key={createArticulo.code}
          mostrar={createArticulo.success ? true : false}
          msg={createArticulo.message}
          stt={createArticulo.success}
        />
      );
    }
  }

  return (
    <Fragment>
      <div
        className={classNames(classes.main, classes.mainRaised)}
        id='main-panel'
      >
        <div className={classes.sections}>
          <div className={classes.sectionWhite}>
            <div>
              <div className={classes.container}>
                {seccionTitulo}
                <div className={classes.marginTop35}>{seccionFormulario}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.sectionfinal}>{showNotification}</div>
    </Fragment>
  );
};

export default withRouter(ArticuloAdd);
